<template>
    <div>
        <div class="splide custom-slide" id="dashboard-slide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(dashboard, k) in arrDashboard"
                        :key="k"
                        @click="clickDashboard(dashboard)">
                        <img class="w-full rounded-10" :src="dashboard.imageUrl">
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

/**
 * @event onLoaded
 */
export default {
    name: "DashboardSlider",
    props: {
        apiConfig: { type: String, required: true },
    },
    data: function() {
        return {
            arrDashboard: [],
        };
    },
    created: function() {
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, this.apiConfig).subscribe((data) => {
                this.arrDashboard = data.length ? data[0].subCampaignDetails : [];
                this.setSlider();

                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
        clickDashboard: function(dashboard) {
            if (dashboard.type == 'link') {
                window.open(dashboard.url, '_blank');
            } else if (dashboard.type == 'campaign') {
                this.$router.push('/campaign/' + dashboard.id);
            } else if (dashboard.type == 'cat') {
                this.$router.push('/campaign/' + dashboard.cat);
            }
        },
        setSlider: function() {
            this.$nextTick(() => {
                new Splide('#dashboard-slide', {
                    type: 'loop',
                    arrows: false,
                    padding: 0,
                    gap: 10,
                    breakpoints: {
                        640: {
                            padding: 30,
                        },
                    }
                }).mount();
            });
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/base/base.scss";

    .splide.custom-slide {
        .splide__pagination {
            bottom: -25px;

            .splide__pagination__page {
                border-radius: 50px;
                opacity: 1;
                background: $color-gray-2;
                transition: width .5s;
                margin: 2px;
                width: 8px;
                height: 8px;

                @include mobile {
                    margin: 2px;
                    width: 8px;
                    height: 8px;
                }

                &.is-active {
                    margin: 2px;
                    width: 19px;
                    height: 8px;
                    background: #1c3e95;
                    transform: unset;

                    @include mobile {
                        // background: #eb1c24;
                        background: #1c3e95;
                        margin: 4px;
                        width: 20px;
                        height: 8px;
                    }
                }
            }
        }
    }
</style>
